<template>
  <div class="staging-drivers">
    <a v-bind:class="{ 'refresh-button button': true, disabled: refreshing }"
       href="javascript:;" @click="refreshDrivers" v-show="driversDisplayed !== null">
      <i v-bind:class="{ 'fas fa-sync': true, 'fa-spin': refreshing }"></i>
    </a>
    <div class="airport-select">
      <label>Select an airport:</label>
      <select v-model.number="airport.selected" v-on:change="onAirportSelect">
        <option value="-1">Choose one</option>
        <option v-for="airport in airport.list" :value="airport.id" :key="airport.id">{{ airport.name }}</option>
      </select>
      <i class="fas fa-caret-down"></i>
    </div>
    <div class="staging-lots">
      <div class="loader" v-show="staging.loading">
        <i class="fa fa-spinner fa-spin"></i>
        <span>Loading staging lots...</span>
      </div>
      <div class="staging-area-error" v-show="staging.error">
        There are no drivers staged for that airport.
      </div>
      <div class="staging-areas" v-if="!staging.loading && staging.list.length > 1 && !staging.error">
        <label>Select a staging lot:</label>
        <select v-model.number="staging.selected" v-on:change="onStagingLotSelect">
          <option value="-1">Choose one</option>
          <option v-for="stagingLot in staging.list" :value="stagingLot.id" :key="stagingLot.id">{{ stagingLot.name }}</option>
        </select>
        <i class="fas fa-caret-down"></i>
      </div>
      <div class="staging-area" v-if="!staging.loading && staging.list.length === 1 && !staging.error">
        Staged Drivers in <strong>{{ staging.list[0].name }}</strong>
      </div>
    </div>
    <div class="driver-list" v-if="driversDisplayed !== null">
      <div class="service-drivers" v-for="(value, key) in driversDisplayed" :key="key">
        <div class="service-title" v-if="value.length > 0">
          <span v-if="key === 'shared'">Shared Ride</span>
          <span v-else-if="key === 'opoli'">Direct Non-Stop</span>
          <span v-else-if="key === 'black'">Sedan</span>
          <span v-else-if="key === 'suv'">SUV</span>
          <span v-else-if="key === 'shuttle'">Private Van</span>
          <span v-else>{{ getServiceName(value[0].serviceTypeId) }}</span>
        </div>
        <table v-if="value.length > 0">
          <thead>
            <tr class="table-header">
              <th></th>
              <th>PRIORITY</th>
              <th>NAME</th>
              <th>LICENSE</th>
              <th>PHONE</th>
              <th>PAX</th>
              <th>STATUS</th>
            </tr>
          </thead>
          <tbody>
            <tr class="driver" v-for="(queue, index) in value" :key="index">
              <td>
                <input type="radio" :value="queue.provider.ID" v-model="selectedDriver"/>
              </td>
              <td>{{ queue.priority }}</td>
              <td>
                <div class="driver-name">
                  <div class="name">
                    <a :href="'#/provider/' + queue.provider.ID" target="_blank">
                      {{ queue.provider.firstName }} {{ queue.provider.lastName }}
                    </a>
                  </div>
                  <div class="prov-options" @mouseover="clearOptionDelay" @mouseout="hideOptions">
                    <i class="fas fa-ellipsis-v fa-lg" @click="showForm(queue.provider.ID, key)"></i>
                    <transition name="slide-down">
                      <div class="options" v-show="showOptions && driverId === queue.provider.ID && key === selectedService">
                        <div class="button cta success block call" @click="callDriver(queue.provider)">
                          <i class="fa fa-phone"></i>{{ $t('provider.call') }}
                        </div>
                        <div class="button cta block send-sms" @click="sendSMS()">
                          <i class="fas fa-comment-dots"></i>{{ $t('provider.sms') }}
                        </div>
                        <div class="button cta warning block send-notif" @click="showNotif">
                          <i class="fas fa-bell"></i>{{ $t('provider.notify') }}
                        </div>
                      </div>
                    </transition>
                  </div>
                </div>
              </td>
              <td>
                <span v-bind:class="'license-type ' + queue.provider.providerAccountType">
                  {{ queue.provider.providerAccountType.toUpperCase() }}
                </span>
              </td>
              <td>
                <a href="javascript:;" @click="callDriver(queue.provider)">
                  {{ queue.provider.countryCode }}{{ queue.provider.phone }}</a>
              </td>
              <td>{{ queue.seatCapacity }}</td>
              <td>{{ queue.status }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <notification-modal :isList="false" ref="notif" :provId="driverId"
      :removeAllActiveUserOption="true" :hideTargetOption="true"></notification-modal>
    <sms-modal :isList="false" ref="sms" :provId="driverId"
      :removeAllActiveUserOption="true" :hideTargetOption="true"></sms-modal>
  </div>
</template>

<script>
/* global CONFIG */
import notificationModal from '../App/NotificationModal'
import smsModal from '../App/SMSModal'

export default {
  name: 'staging-drivers',
  components: {notificationModal, smsModal},
  data () {
    return {
      airport: {
        selected: -1,
        list: []
      },
      staging: {
        selected: -1,
        loading: false,
        list: [],
        error: false
      },
      drivers: null,
      driversDisplayed: null,
      refreshing: false,
      showOptionsDelay: '',
      driverId: null,
      selectedService: '',
      showOptions: false
    }
  },
  computed: {
    selectedDriver: {
      get () { return this.$store.state.dispatch.selectedDriver },
      set (value) { this.$store.commit('dispatch/setSelectedDriver', value) }
    },
    driversTotal () {
      return this.$store.state.dispatch.totalDrivers.staging
    }
  },
  methods: {
    generateDrivers (items) {
      let self = this
      self.drivers = {}
      self.driversDisplayed = null

      for (let i = 0; i < items.length; i++) {
        let item = items[i]
        if (items[i].serviceTypeId <= 5) { continue }

        if (!self.drivers.hasOwnProperty(item.geofenceId)) {
          self.drivers[item.geofenceId] = {
            shared: [],
            opoli: [],
            black: [],
            suv: [],
            shuttle: []
          }
        }

        if (!item.serviceCode && item.serviceTypeId) {
          item.serviceCode = 'a' + item.serviceTypeId
        }

        if (!self.drivers[item.geofenceId][item.serviceCode]) {
          self.drivers[item.geofenceId][item.serviceCode] = []
        }
        if (self.drivers[item.geofenceId][item.serviceCode].findIndex(x => x.provider.ID === item.provider.ID) === -1) {
          self.drivers[item.geofenceId][item.serviceCode].push(item)
        }
      }
    },
    onAirportSelect () {
      let self = this
      if (self.airport.selected === -1) {
        return
      }

      self.staging.loading = true
      self.staging.selected = -1
      self.staging.list = []
      self.staging.error = false
      self.drivers = null
      self.driversDisplayed = null
      self.$sdk.get('/airports/' + self.airport.selected + '/staging', {
        token: self.$store.state.session.sessionToken
      }, r => {
        // console.log('STAGING', r)
        self.staging.loading = false
        if (r.error) {
          self.staging.error = true
          return
        }
        if (r.queue.length <= 0) {
          self.staging.error = true
        }
        self.staging.list = r.staging

        // set code
        for (let i = 0; i < r.queue.length; i++) {
          if (!r.queue[i].serviceCode) {
            r.queue[i].serviceCode = 'a' + r.queue[i].serviceTypeId
          }
        }

        self.generateDrivers(r.queue)
        if (self.staging.list.length === 1) {
          self.driversDisplayed = self.drivers[self.staging.list[0].id]
        }
      })
    },
    onStagingLotSelect () {
      let self = this
      self.driversDisplayed = self.drivers[self.staging.selected]
    },
    refreshDrivers () {
      let self = this
      self.refreshing = true


      self.$sdk.get('/airports/' + self.airport.selected + '/staging', {
        token: self.$store.state.session.sessionToken
      }, r => {
        self.refreshing = false
        if (r.error) {
          return
        }

        self.generateDrivers(r.queue)
        if (self.staging.list.length === 1) {
          self.driversDisplayed = self.drivers[self.staging.list[0].id]
        } else {
          self.onStagingLotSelect()
        }
      })
    },
    callDriver (driver) {
      let self = this
      let phoneNumber = ''
      if (driver.countryCode !== '') {
        phoneNumber += '+'
        phoneNumber += driver.countryCode
      }
      phoneNumber += driver.phone
      self.$plugins.phone.startCall(self, {
        phone: phoneNumber,
        name: driver.firstName + ' ' + driver.lastName
      })
    },
    getServiceName (id) {
      let service = this.$store.state.services.list.filter(x => x.id === id)
      let brand = ''
      if (service.length) {
        brand = '[' + CONFIG.brands.filter(x => x.id === service[0].brandId)[0].code.toUpperCase() + '] '
      }
      return service.length ? brand + service[0].name : 'Cannot find service data...'
    },
    hideOptions () {
      let self = this
      self.showOptionsDelay = setTimeout(function () {
        self.showOptions = ''
      }, 1500)
    },
    clearOptionDelay () {
      if (this.showOptionsDelay) { clearTimeout(this.showOptionsDelay) }
    },
    sendSMS () {
      this.showOptions = ''
      if (this.$refs.sms.showSMSForm()) {
        this.$refs.sms.showSMSForm()
      }
    },
    showNotif () {
      this.showOptions = ''
      if (this.$refs.notif.showNotifForm()) {
        this.$refs.notif.showNotifForm()
      }
    },
    showForm (id, service) {
      this.showOptions = !this.showOptions
      this.driverId = id
      this.selectedService = service
    }
  },
  mounted () {
    let self = this
    self.$store.commit('airports/setLoading', true)
    self.$sdk.get('/airports', {}, r => {
      self.$store.commit('airports/setLoading', false)
      let list = []
      self.airport.list = []
      if (!r.error) {
        r.list.forEach(function (data) {
          let add1 = data.addressLine2 === null ? data.addressLine1 : data.addressLine2
          let add2 = data.addressLine2 === null ? '' : data.addressLine1
          let title = add2 + ' ' + add1 + ', ' + data.city + ', ' + data.state + ' ' + data.zipCode
          if (data.enabled) {
            list.push({
              geofenceId: data.id,
              geofenceType: 'airport',
              address1: add1,
              address2: add2,
              city: data.city,
              lat: data.lat,
              lng: data.lng,
              state: data.state,
              title: data.name || title,
              zip: data.zipCode,
              description: data.description,
              airportCode: data.airportCode,
              locationId: data.locationId
            })
          }
        })
        self.airport.list = r.list
      }
      self.$store.commit('airports/setList', list)
    })
  }
}
</script>

<style lang="scss" scoped>
.staging-drivers {
  font-size: 14px;
  position: relative;

  & .refresh-button {
    position: absolute;
    top: 0;
    right: 0;
    display: inline-block;
    background-color: #26D97A;
    color: #fff;
    padding: 12px;
    border-radius: 3px;
    z-index: 9;
  }
}
.airport-select,
.staging-areas{
  position: relative;
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(0,0,0,0.15);

  & > * {
    display: inline-block !important;
    vertical-align: middle;
  }

  & > i{
    margin-left: -25px;
    color: #aaa;
  }
}

.staging-areas {
  padding-top: 10px;
}

.staging-area {
  text-align: center;
  padding-top: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(0,0,0,0.15);
}

.staging-lots {

  & .loader {
    text-align: center;
    font-weight: 700;
    padding: 15px;
  }
}

.staging-area-error {
  text-align: center;
  padding: 20px 0;
  font-weight: 700;
  color: #F20D0D;
}

.total{
  font-size: 12px;
  font-weight: 700;
  color: #777;
  position: relative;
  text-align: right;
  margin-bottom: 5px;
}

.driver-list {
  margin-top: 8px;

  & .service-drivers {
    position: relative;
  }

  & .service-title {
    font-size: 12px;
    font-weight: 700;
    color: #0D79F2;
    margin-bottom: 3px;
  }
}

table{
  border-collapse: collapse;
  width: 100%;
  margin-bottom: 10px;
}

.table-header{
  color: #8DA0A9;
  font-size: 12px;
  border: 1px solid rgba(0,0,0,0.3);
  background-color: #f5f5f5;

  & th{ padding: 5px 10px;  }
}

.driver{
  background-color: #fff;
  border: 1px solid rgba(0,0,0,0.3);
  position: relative;

  & td{
    padding: 10px;
    text-align: center;
    font-size: 12px;
    margin-bottom: 5px;

    & input{
      margin-top: 0;
      width: 13px;
    }
  }

  & a{ font-weight: 700; }
}

select{
  border-radius: 0;
  outline: 0;
  appearance: none;
  border: 0;
  background-color: #fff;
  padding: 10px;
  border: 1px solid rgba(0,0,0,0.3);
  border-radius: 3px;
  display: inline-block;
  width: 250px;
  margin-left: 10px;
}

.driver-name {
  display: flex;
  .prov-options{
    display: flex;
    align-items: center;
    margin-left: 6px;
    cursor: pointer;
    color: #0D79F2;
    transition: all .4s ease;
    position: relative;

    .fa-ellipsis-v{
      font-size: 14px;
    }
    &:hover{ color: #333; }
    .options{
      transform-origin: top center;
      position: absolute;
      top: 120%;
      z-index: 6;
      width: 200px;
      background: #fff;
      padding: 10px;
      border-radius: 4px;
      box-shadow: 1px 1px 4px rgba(0,0,0, .2);

      .button {
        margin-bottom: 3px;

        i {
          margin-right: 5px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dispatch/StagingDrivers.vue